import { React, computedFn } from '@api'
import {getBoundsRectangle, SelectedShapesTitleShape, SelectedShapesTitleComponent} from '@modules/whiteboard'
import { Utils, TLBounds, HTMLContainer } from '@tldraw/core'
import { intersectLineSegmentBounds } from '@tldraw/intersect'
import {createDefaultStyle, transformRectangle, transformSingleRectangle} from '../shared'
import {TDShapeUtil} from '../TDShapeUtil'

type T = SelectedShapesTitleShape
type E = HTMLDivElement

export class SelectedShapesTitleUtil extends TDShapeUtil<T, E> {
  type = 'selectedShapesTitle' as const
  isStateful = false

  Component = SelectedShapesTitleComponent

  Indicator = (props) => {
    return <HTMLContainer {...props}></HTMLContainer>
  }

  canBind = false

  getShape = computedFn((props: Partial<T>): T => {
    return Utils.deepMerge<T>(
      {
        id: 'id',
        type: 'selectedShapesTitle',
        name: '',
        parentId: 'page',
        childIndex: 1,
        point: [0, 0],
        size: [100, 100],
        rotation: 0,
        style: createDefaultStyle()
      },
      props
    )
  })

  transform = transformRectangle

  transformSingle = transformSingleRectangle

  getBounds = (shape: T) => {
    return getBoundsRectangle(shape)
  }

  getCenter = computedFn((shape: T) => {
    return Utils.getBoundsCenter(this.getBounds(shape))
  })

  hitTestPoint = computedFn((shape: T, point: number[]) => {
    return Utils.pointInBounds(point, this.getBounds(shape))
  })

  hitTestLineSegment = computedFn((shape: T, A: number[], B: number[]) => {
    return intersectLineSegmentBounds(A, B, this.getBounds(shape)).length > 0
  })
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/selectedShapesCombinedTitle/SelectedShapesTitle.tsx